import { render, staticRenderFns } from "./UmsUser.vue?vue&type=template&id=2ac2f27f&"
import script from "./UmsUser.vue?vue&type=script&lang=js&"
export * from "./UmsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports